import * as React from 'react';

import { ScheduleBoardModalContext } from 'af-root/context/scheduleBoardModalContext';

export const useScheduleBoardModals = () => React.useContext(ScheduleBoardModalContext);
